// extracted by css-extract-rspack-plugin
export default {"BetaLabel":"BooleanField-module__BetaLabel__Fwi8L"};